import * as React from "react";
import {SVGProps} from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width={25}
        height={25}
        fill="none"
        viewBox="0 0 25 25"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M8.614 15.611a.75.75 0 0 0 .534-1.276l-2.38-2.41 2.375-2.362A.75.75 0 1 0 8.085 8.5L5.18 11.39a.75.75 0 0 0 0 1.06l2.9 2.941a.75.75 0 0 0 .534.22Z"
            fill="currentColor"
        />
        <path
            d="M5.709 12.669h10.589a.75.75 0 1 0 0-1.5H5.709a.75.75 0 0 0 0 1.5Z"
            fill="currentColor"
        />
        <path
            d="M16.326 20.938H7.613A4.618 4.618 0 0 1 3 16.325v-1.62a.75.75 0 1 1 1.5 0v1.62a3.116 3.116 0 0 0 3.113 3.113h8.713a3.116 3.116 0 0 0 3.108-3.113V7.612A3.115 3.115 0 0 0 16.326 4.5H7.613A3.116 3.116 0 0 0 4.5 7.612v1.539a.75.75 0 0 1-1.5 0V7.612A4.618 4.618 0 0 1 7.613 3h8.713a4.617 4.617 0 0 1 4.608 4.612v8.713a4.618 4.618 0 0 1-4.608 4.613Z"
            fill="currentColor"
        />
    </svg>
);

export default SvgComponent;
